import { useEffect, useState } from 'react'
import { useAppSelector } from '../redux-store/hooks'
import { calculateFullBillingInfo } from '../utils'

const useCurrentBill = () => {
  const bill = useAppSelector((state) => state.table.selectedTable?.billSession)
  const [fullBill, setFullBill] = useState(bill)

  useEffect(() => {
    if (bill) {
      const bInfo = calculateFullBillingInfo(bill)
      setFullBill({ ...bill, billingInfo: bInfo })
    }
  }, [bill?.items, bill?.modeOfPayment])

  return { fullBill, setFullBill }
}

export { useCurrentBill }
